//**
// Bedo's Collectibles custom JS
//**

var CURRENCY_REGEX = /^\d+(\.\d{1,2})?$/;

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

(function() {
    $('form#create_customer').submit(function(e) {
  		
        e.preventDefault();
        
        var message = '';
      
        if ($('#register_first_name').val().trim() == '') {
           if(message != '') {
            message += '<br/>';
          }
          message += 'First name is required';
  		}
      
        var email = $('#register_email').val();
        if ($('#register_email').val().trim() == '') {
          if(message != '') {
            message += '<br/>';
          }
    	  message += 'Email is required';
  		}
      
       if(message != '') {
         	$('#reg-error-message').html(message);
            $('#reg-error-message').show();
    		e.preventDefault(); 
       } else {
        
         
         jQuery.post('/apps/customer-registration', {
           firstName:$('#register_first_name').val(),
           acceptsMarketing: $('#register_acceptingmarketing').val() == 'on' ? true : false,
           email:email
 			})
         	.done(function(data) {
           		if(typeof data != "undefined" && data.hasOwnProperty('id')) {
                  $('#reg-error-message').hide();
                  $('.form-fields-columns').hide();
				  $('.form-action-row').hide();
                 
                  $('#reg-success-message').html('<p><b>You are almost done!</b> An activation email was sent to <b>' + email + '</b>.<br>Open the email and click the link to activate your account.');
                  $('#reg-success-message').show();
                } else {
                  var errorMessage = '';
                  $.each(data, function(key, value) {
                      var field = key[0].toUpperCase() + key.slice(1);
                      errorMessage += field + ' ' + value;
                  });
                  
                  if(errorMessage == '') {
                  	errorMessage = 'Please try at a later time.';
                  }
                  
                  $('#reg-success-message').hide();
                  $('#reg-error-message').html('<p>D\'oh! We could not create your account. ' + errorMessage + '.</p>');
                  $('#reg-error-message').show();
                }
                  
  			})
  			.fail(function(data) {
          	 	$('#reg-success-message').hide();
         		$('#reg-error-message').html('<p>D\'oh! We could not create your account.' + data.statusText);
         		$('#reg-error-message').show();
  			});
       }
	});
})();

(function() {
    $('#edit_account_personal_information').submit(function(e) {
            
        e.preventDefault(); 
      
        var message = '';
        
        if ($('#customer_last_name').val().trim() == '') {
          if(message != '') {
            message += '<br/>';
          }
    	  message += 'Last name is required';
  		}
      
        if ($('#customer_first_name').val().trim() == '') {
           if(message != '') {
            message += '<br/>';
          }
          message += 'First name is required';
  		}
      
        var email = $('#customer_email').val();
        if ($('#customer_email').val().trim() == '') {
          if(message != '') {
            message += '<br/>';
          }
    	  message += 'Email is required';
  		}
         
        if(message != '') {
         	$('#account-edit-error-message').html(message);
            $('#account-edit-error-message').show();
    		
       } else {         
         	
         $(".spinner").show(); //loader icon
         
         var interests = $('input[name=customer_interests]:checked').map(function() {
			return $(this).val();
		 }).get().join(",");
         
         var acceptMarketing = $('#customer_acceptingmarketing').is(":checked");
                     
         $.ajax({
            url: '/apps/customer-registration',
            method: 'PUT',
            headers: {          
              "Accept": "application/json",         
              "Content-Type": "application/json"
            },  
            data: JSON.stringify ({
                id: $('#customer_id').val(),
                lastName:$('#customer_last_name').val(),
           		firstName:$('#customer_first_name').val(),
           		acceptsMarketing: acceptMarketing,
           		email:email,
                about:$('#customer_about').val(),
              	gender:$("input[name='customer_gender']:checked").val(),
                dobMonth:$('#customer_dob_month').val(),
                dobDay:$('#customer_dob_day').val(),
                dobYear: $('#customer_dob_year').val(),
                interests: interests
            })
          })
          .done(function(data) {   
           	if(typeof data != "undefined" && data.hasOwnProperty('id')) {
                  $('#account-edit-error-message').hide();
                  $('#account-edit-success-message').html('Your profiles has been updated.');
                  $('#account-edit-success-message').show();
			} else {
				var errorMessage = '';
                $.each(data, function(key, value) {
					var field = key[0].toUpperCase() + key.slice(1);
					errorMessage += field + ' ' + value;
				});
                  
				if(errorMessage == '') {
					errorMessage = 'Please try at a later time.';
				}
                  
				$('#account-success-error-message').hide();
				$('#account-edit-success-message').html('<p>D\'oh! We could not create your account. ' + errorMessage + '.</p>');
				$('#account-edit-success-message').show();
			}
  		  })
  		  .fail(function( jqXHR, textStatus ) {
			$('#account-success-error-message').hide();
			$('#account-edit-success-message').html('<p>D\'oh! We could not create your account.' + data.statusText);
			$('#account-edit-success-message').show();
          });
       }
	});
})();

$(function() {

    //populate our years select box
  
    for (i = new Date().getFullYear()-13; i > 1920; i--){
      if($('#dob_year').val() == i) {
        $('#customer_dob_year').append($('<option selected />').val(i).html(i));
      } else {
        $('#customer_dob_year').append($('<option />').val(i).html(i));
      }
    }
    //populate our months select box
    for (i = 1; i < 13; i++){
      if($('#dob_month').val() == i) {
        $('#customer_dob_month').append($('<option selected />').val(i).html(i));
      } else {
        $('#customer_dob_month').append($('<option />').val(i).html(i));
      }
    }
  
    //populate our Days select box
    updateNumberOfDays(); 

    //"listen" for change events
    $('#customer_dob_month').change(function(){
        updateNumberOfDays(); 
    });
});

$(function() {
  
  $('#search_grid_sort').change(function() {
		var sortByValue = this.value;
    	var url = window.location.href;
    	var newParams = '';
   	    
    	if(!url.includes('sort_by')) {
      		url = window.location.href + '&sort_by=' + sortByValue;
        } else {
            var url = window.location.href.split('?')[0]+'?';
          	var the = decodeURIComponent(window.location.search.substring(1));
            var parameters = the.split('&');
            
		  	for (i = 0; i < parameters.length; i++) {
              if(!parameters[i].includes('sort_by')) {
              	 newParams += '&' + parameters[i];
              } 
            }
            
            newParams += '&sort_by=' + sortByValue;
        }
    
    	$(location).attr('href', url + newParams.substring(1));
    });
});

//function to update the days based on the current values of month and year
function updateNumberOfDays(){

    $('#customer_dob_day').html('');
    month = $('#customer_dob_month').val();
  
    if(month != 'month') {
      year = $('#customer_dob_year').val();
      days = daysInMonth(month, year);

      for(i=1; i < days+1 ; i++){
        if($('#dob_day').val() == i) {
			$('#customer_dob_day').append($('<option selected />').val(i).html(i));
        } else {
			$('#customer_dob_day').append($('<option />').val(i).html(i));
        }
      }
	} else {
		$('#customer_dob_day').append('<option value="day" selected>Day</option');
    }

}

//helper function
function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
}


// Read More functionality
$(function() {
 	$('.readmore').click(function (event) {

		event.preventDefault();
		var id = '#' + $(this).attr('id') + '-text';
		var display = $(id).css("display");

      	if(display == 'block') {
			$(id).css({'display': 'none'});  
      	} else {
			$(id).css({'display': 'block'});  
      	}
	
      $(this).text($(this).text() == 'Read less...' ? 'Read more...' : 'Read less...');
    });
});

// ACCOUNT OFFER PAGE: Fetch all offers for a customer to load in Customer Offers Page
$(document).ready(function() {
	if (top.location.pathname === '/pages/offers') {

     if($('.account-offers-wrapper').length > 0) {
       
         var offerIds = $('#offerIds').val();
         var customerId = $('#customerId').val();
         var offerUrl = '/apps/make-an-offer/offer/' + offerIds + '?customerId=' + customerId;

         $.ajax({
              url: offerUrl,
              beforeSend: function(){
                $(".spinner").css('display', 'block');
                $(".offerProductDetailsContainer").css('display', 'none');
              },
              success: function(data) {

                $(".spinner").css('display', 'none');
                $(".offerProductDetailsContainer").css('display', 'block');

                $.each(data, function(i, item) {
				  var productId = item.product_id;
                  var bedosMessage = '';
                  console.log('Item status: ' + item.status);
                  console.log('Item buyer acceptor: ' + item.is_buyer_acceptor);
                  if(item.status=='New Seller Offer') {
                    bedosMessage = 'We sent you a counteroffer for this item: <b> ' + currencyFormatter.format(item.seller_offer_amount) + '</b>';
                    $('#' + productId + '_sellerOffer').val( item.seller_offer_amount );
                    $('#' + productId + '_offer_action-buttons').css("display","block");
                  } else if(item.status=='New Buyer Offer') {
                    bedosMessage = 'Thank you for your interest in this item. We are currently reviewing your offer.';
                    $('#' + productId + '_offer_action-buttons').css("display","none");
                  } else if(item.status=='Accepted' && item.is_buyer_acceptor == 'false') {
                    bedosMessage = 'Congratulations! Your offer has been accepted. <p>Click on <b>Pay Now</b> to take you to the product page and begin the order process. Then use either the <b>Add To Cart</b> or <b>Buy button</b> to make the purchase.';
                    $('#' + productId + '_offer_action-buttons-pay').css("display","block");
                    $('#' + productId + '_accountOfferButton').append('<a class="offer-action-pay-now" href=/products/' + item.product_handle + '>Pay Now</a>');
                    $('#' + productId + '_offer_action-buttons').css("display","none");
                    $('#' + productId + '_offer_acceptedAmount').append('<b>Accepted Offer:</b> ' + currencyFormatter.format(item.accepted_offer_amount));	
                  } else if(item.is_buyer_acceptor == 'true') {
                    bedosMessage = 'You have accepted our offer. Click <b>Pay Now</b> to return to product page. Add to cart to begin the checkout process.';
                    $('#' + productId + '_offer_action-buttons-pay').css("display","block");
                    $('#' + productId + '_offer_action-buttons').css("display","none");
                    $('#' + productId + '_accountOfferButton').append('<a class="offer-action-pay-now" href=/products/' + item.product_handle + '>Pay Now</a>');
                    
                    
                    $('#' + productId + '_offer_acceptedAmount').append('<b>Accepted Offer:</b> ' + currencyFormatter.format(item.accepted_offer_amount));	
                  }

                  $('#' + productId + '_offer_productImage')
                  .append('<a href="/products/' + item.product_handle + '"><img width="75%" src="' + item.product_img_url + '"/></a>');

                  $('#' + productId + '_offer_bedosResponse').append('<center>' + bedosMessage + '</center>');

                  //product title
                  $('#' + productId + '_offer_productTitle')
                  .append('<a style="color:#0066c0;text-decoration:none;" href="/products/' + item.product_handle + '" >' + item.product_title + '</a>');

                  // product list price
                  $('#' + productId + '_offer_productListPrice')
                  .append('<b>List Price:</b> ' + currencyFormatter.format(item.product_orig_price));

                  // buyer offer
                  if(item.status != 'Accepted') {
                  	$('#' + productId + '_offer_buyerOffer')
                  	.append('<b>Your Offer:</b> ' + currencyFormatter.format(item.buyer_offer_amount));
                  }
                  // offer expiration
                  if(item.status != 'Accepted') {
                  	$('#' + productId + '_offer_expiration')
                  	.append('<b>Offer Expires:</b> ' + buildFormattedDate(item.expiration));
                  }
                  
                  $('#' + productId + '_sellerOfferExpiration').val(buildFormattedDate(item.expiration));
                });
              },
          error: function(data) {
            if(data.status = 404) {
              console.log('No offer found');
            }

            $('.spinner').css('display', 'none');
            $('.offerProductDetailsContainer').css('display', 'none');
            $('.account-offers-wrapper').css('display','none');
            $('.account-page--column-half').append('<p>You have not made an offer on any products</p>');
          }
        });
      }
  	}
});

// ASK A QUESTION 
$(function() {
  
  $('#product-form--aaq-button').on('click', function(event) {
      	$('.spinner').css('display','none');
    	event.preventDefault();
    	this.blur();
    	$('#aaq-dialog').modal();
  });
  
  
  $('#aaq-dialog').on($.modal.BEFORE_CLOSE, function(event, modal) {
    location.reload(true);
  });
  
  
  $('#aaq-button-submit').click(function (event) {

		var customerId = $('#aaq-customer-id').val();
        var productId = $('#aaq-product-id').val();
        var questionText = $('#aaq-question-text').val();
        var questionEmail = $('#aaq-email').val();

    	if(questionText !='' && questionText != null && (customerId !='' && customerId !=null) 
           || questionEmail != '' && questionEmail != null) {
          
          	$('#aaq-question-text').css({'display':'none'});
    		$('#aaq-button-submit').css({'display':'none'});
	    	$('.spinner').css({'display':'block'}); 
		 
			$.ajax({
              	url: '/apps/make-an-offer/customers/question',
              	method: 'POST',
              	headers: {          
                "Accept": "application/json",         
                "Content-Type": "application/json"
              },  
              data: JSON.stringify ({
				customer_id: customerId,
                product_id: productId,
                email: questionEmail,
                question_text: questionText
              })
            })
            .done(function(data) { 
				$('.submitted').css({'display':'block'});
                $('.spinner').css({'display':'none'}); 
            })
            .fail(function( jqXHR, textStatus ) {
				$('.submitted').text('We were unable to submit your offer. ' +
                                     'Please try again at a later time.');
				$('.submitted').css({'display':'block'});
				$('.submitted').css({'color':'red'});
                $('.spinner').css({'display':'none'});
            });
        } else {
        
        }
    });
});

// CONSIGNMENT FORM
$(function() {

      $('#consignment-form').submit(function (e) {

         $("#consignment-button").attr("disabled", true);
         $("#consignment-button").css('background-color','#47a3af');
         $("#consignment-button").css('border','1px solid #47a3af');

         $('#account-edit-success-message').hide();
         $('#account-edit-error-message').hide();

         e.preventDefault();

		 var name = $('#consignment_name').val();
         var email = $('#consignment_email').val();
         var phone = $('#consignment_phone').val();
         var category = $('#consignment_category').val();
         var description = $('#consignment_description').val();
         var estimatedValue = $('#consignment_estimated_value').val();
          console.log(estimatedValue);
         if(name && (email || phone) && category && description) {
			$.ajax({
               	url: '/apps/make-an-offer/consignments',
               	method: 'POST',
               	headers: {          
                 "Accept": "application/json",         
                 "Content-Type": "application/json"
               },  
               data: JSON.stringify ({
                 isRequest: true,
                 consignorFirstName: '' + name,
                 consignorEmail: '' + email,
                 consignorPhone: '' + phone,
                 quantity: 0,
                 itemsCategory: '' + category,
                 itemsDescription: '' + description,
                 itemsEstimatedValue: estimatedValue
              })
             })
             .done(function(data) { 
                $("#consignment-button").attr("disabled", false);
                $("#consignment-button").css('background-color','#066470');
                $("#consignment-button").css('border','1px solid #066470');
                $("#consignment-button").html('Done &#10003;');
                $('#consignment-success-message').html('Your request has been submitted. We will get in touch with you soon.');
			 	$('#consignment-success-message').show();
                $('#consignment-error-message').hide();
             })
             .fail(function( jqXHR, textStatus ) {
                $("#consignment-button").attr("disabled", false);
                $("#consignment-button").css('background-color','#066470');
                $("#consignment-button").css('border','1px solid #066470');
                $('#consignment-error-message').html('Were not able to submit your request at this time.');
			 	$('#consignment-success-message').hide();
                $('#consignment-error-message').show();
             });
         } else {
            $("#consignment-button").attr("disabled", false);
            $("#consignment-button").css('background-color','#066470');
            $("#consignment-button").css('border','1px solid #066470');
            $('#consignment-error-message').html('Your contact info is required. You can provide either your email or phone.');
            $('#consignment-error-message').show();
         }
    });
});

const getConsignmentItems = function(customerId, collectionId, currentPage) {

  var consignmentsUrl = '/apps/make-an-offer/consignments/summary/' + customerId;

  $('#consignment-items').empty();
  $('.consignor-total-items').empty();
  $('.consignor-total-sold').empty();
  $('.consignor-total-sold-amt').empty();
  $('.consignor-total-payout-amt').empty();
  $('#consignment-pagination').empty();
  $('#consignor-report-last-updated').empty();
  $('.view-payout-history').css('display', 'none');
  $('.view-payout-history').empty();
  $("#payout-history-modal-dialog tbody").empty();
  $('.download-agreement').empty();
  $('.payout-balance').empty();
  
  if(!isNaN(collectionId)) {
    $.ajax({
          url: consignmentsUrl,
          beforeSend: function(){
            $(".spinner").css('display', 'block');
            $("#consignment-report").css('display', 'none');
          },
          success: function(data) {
            $('.spinner').css('display', 'none');
            $("#consignment-report").css('display', 'block');
  
            $('.consignor-total-items').append('<span class=label>Total Items</span><br/>' + data.summary.totalItemsConsigned);
            $('.consignor-total-sold').append('<span class=label>Total Sold</span><br/>' + data.summary.totalCumulativeSold);
            $('.consignor-total-sold-amt').append('<span class=label>Sales</span><br/>' + data.summary.totalCumlativeSoldAmount);
            $('.consignor-total-payout-amt').append('<span class=label>Payout</span><br/>' + data.summary.totalPayoutAmountFormatted);
            $('.payout-balance').append('<b>Payout Balance: ' + data.summary.payoutBalanceFormatted + '</b>');
            
            if(data.payouts && data.payouts.length > 0) {
               $.each(data.payouts, function(i, p) {
                 $("#payout-history-modal-dialog tbody").append('<tr><td class=payout-date>' + p.payout_date + '</td><td class=payout-amount>' + p.payout_amount_formatted + '</td></tr>');
               });
              
              $('.view-payout-history').append('<span class=label>View Payout History</span>');
              $('.view-payout-history').css('display', 'block');
            }
  
            $('#consignor-report-last-updated').append('Last updated: ' + data.summary.createdDate);
            var noPages = Math.ceil(data.summary.totalItemsConsigned / 25);
            var pagination = '';
            for (let i = 1; i <= noPages; i++) {
              if(i == currentPage) {
                pagination += '<span class="pagination inactivePage" id="page_' + i + '">' + i + '</span> ';
              } else {
                pagination += '<span class="pagination activePage" id="page_' + i + '">' + i + '</span> ';  
              }
            }
  
            $('#consignment-pagination').append(pagination);
            
            if(data.items.length > 0) {
              var itemsContainer = '';
              var isProcessingFeeWaived = data.consignmentRates.isProcessingFeeWaived;
              $.each(data.items, function(i, item) {
                var visibility = 'hideItem';
                if((i < (currentPage * 25)) && (i >= (currentPage-1)*25)) {
                  visibility = '';
                }
                
                itemsContainer += '<div class="itemContainer ' + (item.isSold ? 'sold' : 'active') + ' ' + visibility + '">';
                itemsContainer += '<div class=imageContainer><img class=itemImage src=' + item.imageUrl + '></div>';
                itemsContainer += '<div class=details><ol>';
                itemsContainer += '<li><b><a href=https://bedos.com/products/' +  item.shopifyHandle + '>' + item.title + '</a></b></li>';
                itemsContainer += '<li><b>Category: </b>' + item.productType + '</li>';
                if(!item.isSold) {
                  itemsContainer += '<li><br/><b>Store Price: </b>' + item.listPrice + '</li>';
                } else {
                  itemsContainer += '<li>&nbsp;</li>';
                  itemsContainer += '<li>&nbsp;</li>';
                }
                
                const activeLabel = item.status == "active" ? 'Hide Item' : 'Show Item';

                if(item.isMakeOfferEnabled || item.isAtAuction || isProcessingFeeWaived) {
                  itemsContainer +=  '<li style="padding-bottom:5px;"><br/><br/><b>Enabled Options</b><li>';
                }
                
                if(item.isMakeOfferEnabled) {
                  itemsContainer += '<span class="makeOfferFlag">Make Offer</span>&nbsp;&nbsp;';
                }

                if(item.isAtAuction) {
                  itemsContainer += '<span class="makeOfferFlag">eBay Auction</span>&nbsp;&nbsp;';
                }

                if(isProcessingFeeWaived) {
                  itemsContainer += '<span class="makeOfferFlag">3% Fee Waived</span>&nbsp;&nbsp;';
                }
                
                itemsContainer += '</ol></div>';
                
                if(item.isSold) {
                  itemsContainer += '<div class=soldDetails>';
                  itemsContainer += '<p>Sold on ' + item.soldDate + ' for:</p>';
                  itemsContainer += '<p class="soldPrice">' + item.soldPriceFormatted + '</p>';
                  itemsContainer += '<p style="text-align:center;">at <b>' + (item.isSoldOnEbay == true ? 'eBay' :  'Bedo\'s') + '</b></p>';
                  itemsContainer += '</div>';
                }
  
                itemsContainer += '</div>';
              });
              $('#consignment-items').append(itemsContainer);
              $('#consignment-report').css({'display':'block'}); 

              // $('.download-agreement').append('<a href='+ data.agreementUrl + '>Download Agreement</a>');
              
            } else {
              $('.consignment-controls').css({'display':'none'});
            }
          },
          error: function(data) {
            var message = '';
            
            if(data.status = 404) {
              console.log('Response: ' + JSON.stringify(data));
              message = '<p>You do not have any consigned items at this time.</p>';
            }
  
            $('.spinner').css('display', 'none');
            $('#consignment-items').css({'display':'block'});
            $('#consignment-items').append(message);
          }
     });

    $(document).on('click', '.view-payout-history', function() {
      $('#payout-history-modal-dialog').modal({height:'800'});
      
    });

    $(document).on('click','.activePage', function(){
        var divId = this.id;
        var page = divId.split('_')[1];
        $('#page_' + page).remove("activePage");
        $('#page_' + page).addClass("inactivePage");
        $('#page_' + page).unbind("hover");
        var items = $("#consignment-items .itemContainer");
        items.each(function(idx, item) {
          if((idx < (page*25)) && (idx >= ((page-1) * 25))) {
            $(item).css({'display':'block'});
          } else {
            $(item).css({'display':'none'}); 
            $('.pagination').each(function( index ) {
              if(page != index+1) {
                 $(this).addClass("activePage");
                 $(this).removeClass("inactivePage");
              }
            });
          }
        });

       $("html, body").animate({ scrollTop: 0 }, "slow");
    });
  }
};

// MY CONSIGNMENTS
$(document).ready(function() {
  if (top.location.pathname === '/pages/my-consignments') {
       var collectionId = $('#consignorCollectionId').val();
       var customerId = $('#customerId').val();
       var currentPage = 1;

       $(".spinner").css('display', 'none');
    
       if(collectionId != 999) {
           getConsignmentItems(customerId, collectionId, currentPage);
       } else {
         $('#consignorList').change(function() {
            customerId = this.value;
            getConsignmentItems(customerId, 0, currentPage);
         });
       }

       // $(document).on('click','.makeOfferFlag', function(){
       //   const buttonLabel = $(this).text();
       //   const divId = $(this).attr('id');
       //   console.log('Customer: ' + customerId);
       //   console.log('DivId: ' + divId);
       //   const updateMakeAnOfferUrl = '/apps/make-an-offer/consignments/' + customerId + '/products';
       //   console.log('Enable: ' + updateMakeAnOfferUrl);
       //   const makeOfferValue = buttonLabel.includes('Enable') ? 'TRUE' : 'FALSE';
       //   // $.ajax({
       //   //    url: updateMakeAnOfferUrl,
       //   //    beforeSend: function(){
              
       //   //    },
       //   //    success: function(data) {
            
       //   //    }
       //   // }
       // });

       $('#filter-sold').change(function() {
        var showOption = this.value;
        var items = $("#consignment-items .itemContainer");
        if(showOption == 'all') {
          currentPage = 1;
        }
        items.each(function(idx, item) {
          if(showOption == 'all') {
            $(item).css({'display':'block'}); 
          } else if(showOption == 'sold') {
            if($(item).hasClass('active')) {
              $(item).css({'display':'none'}); 
            }
            if($(item).hasClass('sold')) {
              $(item).css({'display':'block'}); 
            }
          } else if(showOption == 'active') {
            if($(item).hasClass('sold')) {
              $(item).css({'display':'none'}); 
            }
             if($(item).hasClass('active')) {
              $(item).css({'display':'block'}); 
            }
          }
        });
    });

    
  }
});

// RESTOCK ALERT
$(function() {
  $('#product-form--nor-button').on('click', function(event) {
    $('.spinner').css('display','none');
    event.preventDefault();
    this.blur();
    $('#restock-dialog').modal();
  });
  
  $('#restock-dialog').on($.modal.BEFORE_CLOSE, function(event, modal) {
    location.reload(true);
  });

  $('#nor-button-submit').on('click', function(event) {
        console.log('restock request');
		var customerId = $('#nor-customer-id').val();
        var productId = $('#nor-product-id').val();
        var customerEmail = $('#nor-email').val();
        
        var requestBody = (customerId) ? {
          customer_id: customerId,
          product_id: productId,
          email: customerEmail
        } : {
          product_id: productId,
          email: customerEmail
        };

    	if(customerEmail != '' && customerEmail != null) {          
    		$('#nor-button-submit').css({'display':'none'});
	    	$('.spinner').css({'display':'block'}); 
		
			$.ajax({
              	url: '/apps/make-an-offer/customers/restockAlert',
              	method: 'POST',
              	headers: {          
                "Accept": "application/json",         
                "Content-Type": "application/json"
              },  
              data: JSON.stringify (requestBody)
            })
            .done(function(data) { 
				$('.submitted').css({'display':'block'});
                $('.spinner').css({'display':'none'}); 
            })
            .fail(function( jqXHR, textStatus ) {
              console.log('Fail: ' + textStatus);
				$('.submitted').text('We were unable to send your restock alert request. ' +
                                     'Please try again at a later time.');
				$('.submitted').css({'display':'block'});
				$('.submitted').css({'color':'red'});
                $('.spinner').css({'display':'none'});
            });
        } else {
        
        }
    });
});

// PROFIT CALCULATOR
$(function() {
  
  $('#product-form--calcprofit-button').on('click', function(event) {
      	$('.spinner').css('display','none');
    	event.preventDefault();
    	this.blur();
    	$('#calcprofit-dialog').modal();
  });
  
  
  $('#calcprofit-dialog').on($.modal.BEFORE_CLOSE, function(event, modal) {
    location.reload(true);
  });
  
  
  $('#calcprofit-button-submit').click(function (event) {
    
		var costOfGood = parseFloat($('#calcprofit-cog').val());
    	var offerAmount = parseFloat($('#calcprofit-offer').val());
    	var shippingCost = parseFloat($('#calcprofit-shipping').val() || 0);
    	var paymentRate = parseFloat($('#calcprofit-paymentmethod').val());
        var doChargeSalesTax = $('#calcprofit-catax').is(':checked');
        var doChargeDonation = $('#calcprofit-donation').is(':checked');
        var salesTaxRate = doChargeSalesTax ? 0.1025 : 0.00;
    
      
        var donationAmount = doChargeDonation ? offerAmount * 0.1 : 0;
        var transactionFee = paymentRate > 0? (offerAmount * paymentRate) + 0.30 : 0;
        var salesTax = offerAmount * salesTaxRate;
        var totalCost = costOfGood + transactionFee + salesTax + shippingCost + donationAmount;
        var profit = offerAmount - totalCost;
        var margin = (profit / offerAmount) * 100;
    
        console.log('cost of good: ' + costOfGood);
        console.log('offerAmount: ' + offerAmount);
        console.log('shippingCost: ' + shippingCost);
        console.log('paymentRate: ' + paymentRate);
        console.log('doChargeSalesTax: ' + doChargeSalesTax);
        console.log('salesTaxRate: ' + salesTaxRate);
        console.log('transactionFee: ' + transactionFee);
        console.log('salesTax: ' + salesTax);
        console.log('totalCost: ' + totalCost);
        console.log('profit: ' + profit);
        console.log('margin: ' + margin);    
        
        $('#calcprofit-donation').text('$' + donationAmount.toFixed(2));
        $('#calcprofit-totalcost').text('$' + totalCost.toFixed(2));
        $('#calcprofit-profitamount').text('$' + profit.toFixed(2));
        $('#calcprofit-margin').text(margin.toFixed(2) + '%');
    });
});

$(document).ready(function() {
  if (top.location.pathname === '/pages/consignment-form') {
    // const webcamElement = $('#webcam');
    // const canvasElement = $('#canvas');
    // const snapSoundElement = $('#snapSound');
    // const webcam = new Webcam(webcamElement, 'user', canvasElement, snapSoundElement);
    // webcam.start()
    //  .then(result =>{
    //     console.log("webcam started");
    //  })
    //  .catch(err => {
    //    console.log(err);
    //  });

    // let picture = webcam.snap();
    // document.querySelector('#download-photo').href = picture;
  }
  
})

// Make an offer dialog
$(function() {
  
    // PRODUCT PAGE: Open offer modal on 'Make Offer' button click
 	$('.product-form--mao').click(function (event) {
      var buttonText = $('.product-form--mao').text();
      $('.spinner').css('display','none');
      if(!buttonText.includes('Pending Sale')) {
      	event.preventDefault();
	  	this.blur(); // Manually remove focus from clicked link.
      	$('#mao-dialog').modal();
      }
    });
  
  	$('#mao-dialog').on($.modal.BEFORE_CLOSE, function(event, modal) {
		location.reload(true);
    });
  
    // PRODUCT PAGE: Initiate offer from offer modal
    $('#mao-button-submit-offer').click(function (event) {
		var customerId = $('#mao-offer-customer-id').val();
        var productId = $('#mao-offer-product-id').val();
        var productTitle = $('#mao-offer-product-title').val();
		var productHandle = $('#mao-offer-product-handle').val();
        // var emailAddress = $('#mao-email-value').val();
        var offerPrice = $('#mao-offer-value').val();
        var currentPrice = $('#mao-offer-currency-price').val();
        
        currentPrice = currentPrice.substring(1);
        currentPrice = currentPrice.replace(',', '');
        
        var isInvalidPrice = false;
        // var isInvalidEmail = false;

       // var validEmailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if(offerPrice =='' 
            || offerPrice == null 
                || eval(offerPrice) <= 0
                    || !CURRENCY_REGEX.test(offerPrice)
                       || eval(offerPrice) >= currentPrice) {

            isInvalidPrice = true;
        }

        // Only validate email if the user is not logged in
        // if(customerId == null && (emailAddress =='' 
        //     || emailAddress == null 
        //         || !emailAddress.match(validRegex))) {
        //     isInvalidEmail = true;
        // }

        if(isInvalidPrice) {
          $('.mao-offer-required').css({'visibility':'visible'});
        }

        // if(isInvalidEmail) {
        //   $('.mao-email-required').css({'visibility':'visible'});
        // }
  
        if(!isInvalidPrice) {
          $('.mao-offer-required').css({'visibility':'hidden'});
          // $('.mao-email-required').css({'visibility':'hidden'});
          $('.spinner').css({'display':'block'});
          $('.submitOffer').css({'display':'none'});
          $('.legal').css({'display':'none'});
          $('#yourOfferLabel').css('display','none');
          // $('#emailLabel').css('display','none');
          $('#mao-offer-value').css('display','none');
          // $('#mao-email-value').css('display','none');

          console.log(JSON.stringify ({
            productId: productId,
            productTitle: productTitle,
            productHandle: productHandle,
            // customerEmail: emailAddress,
            customerId: customerId,
            offerAmount: offerPrice }));
          $.ajax({
            url: '/apps/make-an-offer/offer/',
            method: 'POST',
            headers: {          
            "Accept": "application/json",         
            "Content-Type": "application/json"
          },  
          data: JSON.stringify ({
            productId: productId,
            productTitle: productTitle,
            productHandle: productHandle,
            // customerEmail: emailAddress,
            customerId: customerId,
            offerAmount: offerPrice })
          })
          .done(function(data) { 
              $('.submitted').css({'display':'block'});
              $('.spinner').css({'display':'none'});
              // $('.mao-button--text').text('Review Pending Offer');
          })
          .fail(function( jqXHR, textStatus ) {
              $('.legal').css({'display':'block'});
              $('.submitOffer').css({'display':'block'});
              $('#yourOfferLabel').css('display','block');
              $('#mao-offer-value').css('display','block');
              $('.submitted').text('We were unable to submit your offer. ' +
                                   'Please try again at a later time.');
              $('.submitted').css({'display':'block'});
              $('.submitted').css({'color':'red'});
              $('.spinner').css({'display':'none'});
          });
        }
    });
  
    // ACCOUNT OFFER PAGE: Open Offer Modal 
    $(".offerProductDetailsContainer").on("click", "button", function() {
		var id = $(this).attr('id');
      	var properties = id.split("_");
      	var productId = properties[0];
      	var customerId = properties[1];
		var action = properties[2];
      	var sellerOfferAmount = $('#' + productId + '_sellerOffer').val();
        var sellerOfferExpiration = $('#' + productId + '_sellerOfferExpiration').val();
      
		$('#seller-offer-amount').text('Counter offer: ' + currencyFormatter.format(sellerOfferAmount));
        $('#seller-offer-expiration').text(sellerOfferExpiration);
        $('#mao-counter-seller-offer').val(sellerOfferAmount);
        $('#mao-counter-product-id').val(productId);
      
      	//Suppress modal on the account offer page when the button reads 'Pay Now'
        var buttonText =  $('#'+id).text();
      	if(!buttonText.includes('Pay')) {
      		$('#mao-dialog').modal();
      	}
	});
  
    // PRODUCT PAGE: Accept seller counter offer
  	$('#mao-button-submit-accept').click(function (event) {
      
		var productId = $('#mao-counter-product-id').val();
      	var customerId = $('#mao-counter-customer-id').val();
	    var sellerOfferAmount = $('#mao-counter-seller-offer').val();
      
      	$('.spinner').css({'display':'block'});
		$('.counter').css({'display':'none'});
		$('.accept').css({'display':'none'});
        $('.actions').css('display','none');
        $('.legal').css('display','none');
        $('#makeAnOfferLabel').css('display','none');
        $('#mao-counter-offer-amount').css('display','none');
      
        $.ajax({
          url: '/apps/make-an-offer/offer/',
          method: 'PUT',
          headers: {          
            "Accept": "application/json",         
            "Content-Type": "application/json"
          },  
          data: JSON.stringify ({
            productId: productId,
            customerId: customerId,
            acceptedOfferAmount: sellerOfferAmount,
            isBuyerAcceptor: true,
            key: 'offer_' + customerId
          })
        })
        .done(function(data) {
          $('#mao-dialog').modal('hide');
        })
        .fail(function( jqXHR, textStatus ) {
          console.log(textStatus);
        });
    });
  
  	$('#mao-button-submit-counter').click(function (event) {
      
		var customerId = $('#mao-counter-customer-id').val();
		var productId = $('#mao-counter-product-id').val();
        var offerPrice = $('#mao-counter-offer-amount').val();
      
        $('.spinner').css({'display':'block'});
		$('.counter').css({'display':'none'});
		$('.accept').css({'display':'none'});
        $('.actions').css('display','none');
        $('.legal').css('display','none');
        $('#makeAnOfferLabel').css('display','none');
        $('#mao-counter-offer-amount').css('display','none');
      
		$.ajax({
          url: '/apps/make-an-offer/offer/',
          method: 'PUT',
          headers: {          
            "Accept": "application/json",         
            "Content-Type": "application/json"
          },  
          data: JSON.stringify ({
            productId: productId,
            customerId: customerId,
            buyerOfferAmount: offerPrice,
            key: 'offer_' + customerId
          })
        })
        .done(function(data) { 
          $('.counterMessage').css({'display':'block'});
          $('.spinner').css({'display':'none'});
          // $('.mao-button--text').text('Review pending offer');

        })
        .fail(function( jqXHR, textStatus ) {
          console.log(textStatus);
        });      
    });
    
  
     $('#mao-button-login').click(function (event) {
      	document.location.href = '/account/login?redirect_page='+ window.location.pathname;
     });
  
   $('#mao-button-register').click(function (event) {
      	document.location.href = '/account/register';
     });
});


var buildFormattedDate = function(value) {

      date = new Date(value);
      year = date.getFullYear();
      month = date.getMonth()+1;
      dt = date.getDate();

      if (dt < 10) {
      dt = '0' + dt;
      }
      if (month < 10) {
      month = '0' + month;
      }
      var monthName = date.toLocaleString('en-us', { month: 'long' });
      return monthName + ' ' + dt + ', ' + year;
    }

// To open external links in a new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

$(function() {
  if (top.location.pathname.includes('products')) {
    console.log(top.location.pathname);

    var activeTab = 'details';

    // initialize to Detail
    $('#detailsContent').css({'display': 'block'});  
    $('#details').addClass('active');  

    $(document).on('click','.tablinks', function(){
      var id = $(this).attr('id');

      $('#' + activeTab + 'Content').css({'display': 'none'});  
      $('#' + activeTab).removeClass('active'); 
      
      $('#' + id + 'Content').css({'display': 'block'});  
      $('#' + id).addClass('active'); 

      activeTab = id;
    });
  }
});